import React, { useState, useContext } from "react";
import { Button, Col, Container, Form, Row, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import ApiService from "../../helper/api";
import AlertService from "../../helper/alertService";
import { LoadingContext } from "../../App";
import Header from "../../componets/Header";
import { FaCircleArrowLeft } from "react-icons/fa6";
import { PiCaretLeftBold } from "react-icons/pi";
import { PiCaretRightBold } from "react-icons/pi";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/grid";
import "swiper/css/pagination";
import "swiper/css/navigation";
import ActionButton from "../../componets/ActionButon";

const SwiperNavigation = ({ children, className = "", count = 3 }) => {
	const [ref, setRef] = useState(null);
	return (
		<div className="d-flex align-items-center justify-content-between">
			<div
				className="me-2"
				style={{ cursor: "pointer" }}
				onClick={() => ref?.slidePrev()}>
				<PiCaretLeftBold size={30} color="rgb(13, 110, 253)" />
			</div>
			<Swiper
				slidesPerView={1}
				onSwiper={swiper => setRef(swiper)}
				allowTouchMove
				loop={true}
				className={"w-full !px-[20px] " + className}
				modules={[Navigation]}
				breakpoints={{
					1200: {
						slidesPerView: 4,
						spaceBetween: 40,
					},
					900: {
						slidesPerView: 2,
						spaceBetween: 30,
					},
				}}>
				{children}
			</Swiper>

			<div
				className="ms-2"
				style={{ cursor: "pointer" }}
				onClick={() => ref?.slideNext()}>
				<PiCaretRightBold size={30} color="rgb(13, 110, 253)" />
			</div>
		</div>
	);
};

const Scanner = props => {
	//const carouselRef = useRef(null);
	// const navaigate = useNavigate();
	const [search, setSearch] = useState("");
	const [address, setAddress] = useState("");
	const [/*name,*/ setName] = useState("");
	const [balance, setBalance] = useState([]);
	const [transactions, setTransactions] = useState([]);
	const {
		addPageSpinner,
		removePageSpinner,
		pageSpinner,
		addButtonSpinner,
		removeButtonSpinner,
	} = useContext(LoadingContext);

	// const prevRef = useRef(null);
	// const nextRef = useRef(null);

	const onSubmit = (event, search = "") => {
		event && event.preventDefault();
		checkAddressAllNetworks(search);
		//getRegularTransactionsAddress(search);
	};

	const checkAddressAllNetworks = () => {
		if (!search) {
			return false;
		}
		const spinnerId = Math.random();
		addPageSpinner(spinnerId);
		ApiService.checkAddressAllNetworks(search)
			.then(response => {
				if (response && response.data) {
					setBalance(response.data);
				} else {
					setBalance([]);
				}
			})
			.catch(error => AlertService.alert("error", error))
			.finally(() => {
				removePageSpinner(spinnerId);
				setAddress(search);
				setSearch("");
			});
	};

	// const handlePrevious = () => {
	//     if (carouselRef.current) {
	//         carouselRef.current.previous();
	//     }
	// };

	// const handleNext = () => {
	//     if (carouselRef.current) {
	//         carouselRef.current.next();
	//     }
	// };

	const getRegularTransactionsAddress = (
		spinnerId,
		name = "",
		address = "",
	) => {
		if (!search && !name) {
			return false;
		}
		addButtonSpinner(spinnerId);
		ApiService.getRegularTransactionsAddress(address, name)
			.then(response => {
				if (response && response.data) {
					setTransactions(response.data);
				} else {
					setTransactions([]);
				}
			})
			.catch(error => AlertService.alert("error", error))
			.finally(() => {
				// removePageSpinner(spinnerId)
				removeButtonSpinner(spinnerId);
			});
	};

	return (
		<div>
			<Header>
				<div className="d-flex justify-content-between w-100">
					<div className="d-flex gap-2 align-items-center">
						<Link to="/">
							<FaCircleArrowLeft size={20} />
						</Link>
						<h4 className="mb-0">Scanner</h4>
					</div>
					{/* <Button
                        variant="primary"
                        size="sm"
                        className="px-3 d-flex align-items-center"
                    >
                        <IoFilter className="me-2" />
                        Show Filter
                    </Button> */}
					{/* <Form onSubmit={onSubmit}>
						<Form.Group
							controlId="search"
							className="d-flex gap-2 align-items-center">
							<Form.Control
								type="search"
								value={search}
								size="sm"
								placeholder="Ex. 0x1B30FACA626bD385583aDC07d5c06799257730cA"
								onChange={event => setSearch(event.target.value)}
							/>
							<Button
								size="sm"
								variant="primary"
								type="submit"
								disabled={pageSpinner.length}>
								Search
							</Button>
						</Form.Group>
					</Form> */}
				</div>
			</Header>
			<div mt={4} className="d-flex justify-content-between w-100">
				<Form
					onSubmit={event => onSubmit(event, search)}
					style={{ width: "30rem" }}>
					<Form.Group
						controlId="search"
						className="d-flex gap-2 align-items-center">
						<Form.Control
							type="search"
							value={search}
							size="sm"
							placeholder="Address..."
							onChange={event =>
								setSearch(event.target.value ? event.target.value : "")
							}
						/>
						<Button
							disabled={!search.trim().length}
							size="sm"
							variant="primary"
							type="submit">
							Search
						</Button>
					</Form.Group>
				</Form>
			</div>

			<Row className="mb-5">
				{address ? (
					<Col sm={12} className=" mt-4">
						<h5 className="fw-bold"> Address :{address}</h5>
					</Col>
				) : null}
				<Col sm={12}>
					{balance && balance.length ? (
						<SwiperNavigation>
							{balance.map((item, index) => (
								<SwiperSlide className="rounded">
									<div key={index} className="border rounded p-3">
										<div className="d-flex gap-2 align-items-center pb-2">
											<img
												className="me-2 "
												src={item.chainLogo}
												style={{
													width: 40,
													height: 40,
													objectFit: "contain",
												}}
												alt="logo"
											/>
											<h5>
												<b className="max-line-1 ">{item.chainNetwork}</b>
											</h5>
										</div>

										<hr className="m-0" />
										<div className="d-flex align-items-center mt-2 gap-2">
											<span>Balnce-</span>
											<div className="d-flex align-items-center  gap-1">
												<b
													className="ms-1 max-line-1"
													style={{ wordBreak: "break-all" }}
													title={item.balance ? item.balance : 0}>
													{item.balance ? item.balance : 0}
												</b>
												<img
													className="me-2"
													src={item.currencyLogo}
													style={{
														width: 20,
														height: 20,
														objectFit: "contain",
													}}
													alt="logo"
												/>
											</div>
										</div>

										<div className="d-flex align-items-center mt-2 gap-2">
											<span>Tokens- </span>
											<div className="d-flex align-items-center  gap-1">
												<b
													className="ms-1 max-line-1"
													style={{ wordBreak: "break-all" }}
													title={item.tokenCount ? item.tokenCount : 0}>
													{item.tokenCount ? item.tokenCount : 0}
												</b>
											</div>
										</div>

										<div className="mt-2 d-flex justify-content-center">
											<ActionButton
												disabled={item.isActive}
												buttonSpinnerId={`${item.address}_${index}`}
												size="sm"
												variant={item.isActive ? "primary" : "secondary"}
												type="button"
												buttonName={item.isActive ? "View" : "Not active"}
												className={`${item.isActive ? "pe-none" : ""}`}
												cb={() => {
													setName(
														item.nameBlockchain ? item.nameBlockchain : "",
													);
													getRegularTransactionsAddress(
														`${item.address}_${index}`,
														item.nameBlockchain,
														item.address,
													);
												}}
											/>
										</div>
									</div>
								</SwiperSlide>
							))}
						</SwiperNavigation>
					) : null}
				</Col>
				{transactions && transactions.length ? (
					<Col sm={12}>
						<div>
							<h4 className="mb-3">Transactions</h4>
						</div>
						<Table responsive hover>
							<thead>
								<tr>
									<th>#</th>
									<th>TimeStamp</th>
									<th>BlockNumber</th>
									<th>BlockHash</th>
									<th>From</th>
									<th>To</th>
									<th>ContractAddress</th>
									<th>CumulativeGasUsed</th>
									<th>Gas</th>
									<th>GasPrice</th>
									<th>GasUsed</th>
									<th>Hash</th>
									<th>Input</th>
									<th>Value</th>
								</tr>
							</thead>
							<tbody>
								{transactions.map((transaction, index) => (
									<tr key={index}>
										<td className="text-center">
											<span>{index + 1}</span>
										</td>

										<td
											style={{
												color: transaction.isError ? "green" : "red",
											}}>
											<span
												style={{
													minWidth: "100px",
													maxWidth: "100px",
												}}
												className="max-line-2"
												title={transaction.timeStamp}>
												{new Date(transaction.timeStamp + "Z").toLocaleString(
													undefined,
												)}
											</span>
										</td>

										<td>
											<span
												style={{
													minWidth: "80px",
													maxWidth: "80px",
													cursor: "pointer",
												}}
												className="max-line-1 web-link"
												target="_blank"
												rel="noopener noreferrer"
												title={transaction.blockNumber}>
												<Button
													ml={2}
													onClick={event => {
														onSubmit(event, transaction.blockNumber);
														setSearch(transaction.blockNumber);
													}}>
													<u>{transaction.blockNumber}</u>
												</Button>
											</span>
										</td>
										<td>
											<span
												style={{
													minWidth: "100px",
													maxWidth: "100px",
													cursor: "pointer",
												}}
												className="max-line-1 web-link"
												target="_blank"
												rel="noopener noreferrer"
												title={transaction.blockHash}>
												<Button
													ml={2}
													onClick={event => {
														onSubmit(event, transaction.blockHash);
														setSearch(transaction.blockHash);
													}}>
													<u>{transaction.blockHash}</u>
												</Button>
											</span>
										</td>
										<td>
											<span
												style={{
													minWidth: "100px",
													maxWidth: "100px",
												}}
												className="max-line-1"
												title={transaction.from}>
												<Button
													onClick={event => {
														setSearch(transaction.from);
														onSubmit(event, transaction.from);
													}}>
													{transaction.from}
												</Button>
											</span>
										</td>
										<td>
											<span
												style={{
													minWidth: "100px",
													maxWidth: "100px",
												}}
												className="max-line-1"
												title={transaction.to}>
												<Button
													onClick={event => {
														setSearch(transaction.to);
														onSubmit(event, transaction.to);
													}}>
													{transaction.to}
												</Button>
											</span>
										</td>

										<td>
											<span
												style={{
													minWidth: "100px",
													maxWidth: "100px",
												}}
												className="max-line-1"
												title={transaction.contractAddress}>
												{transaction.contractAddress}
											</span>
										</td>
										<td>
											<span
												style={{
													minWidth: "100px",
													maxWidth: "100px",
												}}
												className="max-line-1"
												title={transaction.cumulativeGasUsed}>
												{transaction.cumulativeGasUsed}
											</span>
										</td>

										<td>
											<span
												style={{
													minWidth: "100px",
													maxWidth: "100px",
												}}
												className="max-line-1"
												title={transaction.gas}>
												{transaction.gas}
											</span>
										</td>
										<td>
											<span
												style={{
													minWidth: "100px",
													maxWidth: "100px",
												}}
												className="max-line-1"
												title={transaction.gasPrice}>
												{transaction.gasPrice}
											</span>
										</td>
										<td>
											<span
												style={{
													minWidth: "100px",
													maxWidth: "100px",
												}}
												className="max-line-1"
												title={transaction.gasUsed}>
												{transaction.gasUsed}
											</span>
										</td>
										<td>
											<span
												style={{
													minWidth: "100px",
													maxWidth: "100px",
												}}
												className="max-line-1"
												title={transaction.hash}>
												{transaction.hash}
											</span>
										</td>
										<td>
											<span
												style={{
													minWidth: "100px",
													maxWidth: "100px",
												}}
												className="max-line-1"
												title={transaction.input}>
												{transaction.input}
											</span>
										</td>
										<td>
											<span
												style={{
													minWidth: "100px",
													maxWidth: "100px",
												}}
												className="max-line-1"
												title={transaction.value}>
												{transaction.value}
											</span>
										</td>
									</tr>
								))}
							</tbody>
						</Table>
					</Col>
				) : null}
			</Row>
		</div>
	);
};

export default Scanner;
